"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWithdrawV2Events = fetchWithdrawV2Events;
const maps_js_1 = require("../../common/maps.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
async function fetchWithdrawV2Events(params) {
    const eventTypes = [maps_js_1.poolInfo["ALPHA"].withdrawV2EventType];
    const eventsPromises = eventTypes.map(async (eventType) => {
        if (!eventType) {
            console.error(`Event type not found: ${eventTypes}`);
            throw new Error("Incomplete Event Types");
        }
        const events = await (0, fetchEvents_js_1.fetchEvents)({
            startTime: params.startTime,
            endTime: params.endTime,
            eventTypes: [eventType],
            order: params.order,
        });
        return events;
    });
    const events = (await Promise.all(eventsPromises)).flat();
    const withdrawV2EventNodes = events.map((e) => {
        return e;
    });
    return withdrawV2EventNodes;
}
//# sourceMappingURL=fetchWithdrawV2Events.js.map